import { TransportInterface } from "../TransportInterface";
import Rollbar from "../../API/Rollbar/Rollbar";

class RollbarTransport implements TransportInterface {

  public log(message: string, shouldLogToTransport?: boolean, data?: any): Promise<any> {
    return Rollbar.log(message, shouldLogToTransport, data);
  }

  public warn(message: string): Promise<any> {
    return Promise.resolve(message);
  }

  public debug(data: any, prefix: string): Promise<any> {
    return Promise.resolve([data, prefix]);
  }

  public logError(err: any, level?: string): Promise<any> {
    return Rollbar.logError(err, level);
  }
}

export { RollbarTransport };
